/**
 * Filter types that render INLINE in the report bar instead of behind a pill.
 *
 * Section E (Himaad Riaz, UX review 2026-08-24) — "the one real UX concern".
 * Consolidating every filter into a pill made the report page clean and made
 * every control cost a minimum of two clicks, sometimes three; a complex report
 * like Timekeeper Analysis is 7-10 clicks just to set its filters.
 *
 * The date filter is the one that comes out of the popover, and it needed no
 * analytics to decide (Jordan + Himaad, 2026-08-24): "date is almost always
 * going to change for any report that has a date control, which is most of
 * them." It is also the control that SCOPES THE MONEY, so having it visible
 * rather than folded away is a correctness property as much as a click count —
 * a reader can see the period the figures cover without opening anything.
 *
 * `filterTypeName` is the ONLY type discriminator in the system (see
 * FILTER_COMPONENTS in ReportFilterPanel.jsx), so this set is keyed on it.
 *
 * WHY A .js FILE AND NOT .jsx: eslint's react-refresh/only-export-components
 * fires on a non-component export from a .jsx module here, which is also why
 * ReportFilterFields is exported as a component rather than the raw
 * FILTER_COMPONENTS map. The path and the export NAME are both consumed from
 * ReportView.jsx as well — do not rename either without checking both.
 */
export const INLINE_FILTER_TYPES = new Set(['DATE', 'SIMPLEDATE'])
